import { createTheme } from "@mui/material/styles";
import { forEach, merge } from "lodash";

import { themeColors } from "./themeColors";
import themeOptions from "./themeOptions";

function createExpThemes() {
	let themes = {};

	forEach(themeColors, (value, key) => {
		themes[key] = createTheme(merge({}, themeOptions, value));
	});

	return themes;
}

export const themes = createExpThemes();
